"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.parseError = function (error) {
  if (!error) return '';
  var message = typeof error === 'string' ? error : error.message;
  return message.replace(/Network error: |GraphQL error: |Node error: /g, '');
};